import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.eventsHighlightsList.replace(appPath.eventsHighlights, ''),
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'eventsHightlightList' */ './component')],
			render: ([EventsHightlightList]) => <EventsHightlightList />,
		},
	],
};

export default routes;
